var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2292",
    "data-name": "Group 2292",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.824,
    height: 25.824,
    viewBox: "0 0 25.824 25.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M0,0H25.824V25.824H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M19.216,7.3h3.228A1.076,1.076,0,0,1,23.52,8.38V21.292a1.076,1.076,0,0,1-1.076,1.076H3.076A1.076,1.076,0,0,1,2,21.292V4.076A1.076,1.076,0,0,1,3.076,3h16.14ZM4.152,9.456v10.76H21.368V9.456Zm0-4.3V7.3H17.064V5.152ZM15.988,13.76h3.228v2.152H15.988Z",
    transform: "translate(0.152 0.228)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.2752e2097ecb22cd0425efcfe63bbfa2.svg";
export { ForwardRef as ReactComponent };